import { useId, useLayoutEffect, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './SummarySection.module.css';

export const SummarySection = ({ titulo, texto }: { titulo: string; texto: string }) => {
	const [expanded, setExpanded] = useState(false);
	const [canExpand, setCanExpand] = useState(false);
	const textRef = useRef<HTMLDivElement>(null);
	const textId = useId();

	useLayoutEffect(() => {
		const element = textRef.current;
		if (!element) return;

		const measure = () => {
			const lineHeight = Number.parseFloat(window.getComputedStyle(element).lineHeight);
			setCanExpand(element.scrollHeight > lineHeight * 3 + 1);
		};
		measure();
		const observer = new ResizeObserver(measure);
		observer.observe(element);
		return () => observer.disconnect();
	}, [texto]);

	return (
		<section className={styles.summarySection}>
			<h2 className={styles.summarySectionTitle}>{titulo}</h2>
			<div
				id={textId}
				ref={textRef}
				className={`${styles.summaryBody} ${expanded ? '' : styles.summaryBodyCollapsed}`}
			>
				<ReactMarkdown remarkPlugins={[remarkGfm]}>{texto}</ReactMarkdown>
			</div>
			{canExpand && (
				<button
					type="button"
					className={styles.expandButton}
					aria-expanded={expanded}
					aria-controls={textId}
					onClick={() => setExpanded((value) => !value)}
				>
					{expanded ? 'Ver menos' : 'Ver mais'}
					<span className={styles.expandIcon} aria-hidden="true" />
				</button>
			)}
		</section>
	);
};
